<template>
  <layout-ucenter>
    <!-- menu -->
    <template slot="menu">
      <!-- 供应商 & 管理员 -->
      <el-menu v-if="user.type == 2 || user.type == 3" mode="vertical" :router="true" default-active="1">
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-share"></i> 内容管理</template>
          <el-menu-item index="/share/my-content">我的内容</el-menu-item>
          <el-menu-item index="/share/platform-content">平台内容</el-menu-item>
          <el-menu-item index=""><a href="javascript:void(0)" @click="$refs.newContent.open()" target="_blank" class="d-b c-i" style="text-decoration: none;">制作内容</a></el-menu-item>
          <el-menu-item index="/share/product" v-if="user.type == 3">推荐内容</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-kkt-wechat"></i> 公众号管理</template>
          <el-menu-item index="/weixin/authorize">授权管理</el-menu-item>
          <el-menu-item index="/weixin/authorize-history" v-if="user.type == 3">授权记录</el-menu-item>
          <el-menu-item index="/weixin/menus">菜单管理</el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-setting"></i> 运营管理</template>
          <el-menu-item index="/share/category-list">内容分类管理</el-menu-item>
          <el-menu-item index="/share/banner">Banner管理</el-menu-item>
        </el-menu-item-group>
      </el-menu>
      <!-- 普通用户 -->
      <el-menu v-else mode="vertical" :router="true" default-active="1">
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-share"></i> 内容管理</template>
          <el-menu-item index="/share/my-content">我的内容</el-menu-item>
          <el-menu-item index="/share/platform-content">平台内容</el-menu-item>
          <el-menu-item index=""><a href="javascript:void(0)" @click="$refs.newContent.open()" target="_blank" class="d-b c-i" style="text-decoration: none;">制作内容</a></el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <template slot="title"><i class="el-icon-kkt-wechat"></i> 公众号管理</template>
          <el-menu-item index="/weixin/authorize">授权管理</el-menu-item>
          <el-menu-item index="/weixin/menus">菜单管理</el-menu-item>
        </el-menu-item-group>
      </el-menu>
      <!-- 制作内容 -->
      <new-content-dialog ref="newContent"></new-content-dialog>
    </template>
  </layout-ucenter>
</template>

<script>
  import LayoutUcenter from './layout-ucenter'
  import NewContentDialog from './newContentDialog'
  import authService from 'service/authService'

  export default {
    components: {
      LayoutUcenter,
      NewContentDialog
    },

    computed: {
      user () {
        return authService.currentUser
      }
    }
  }
</script>

<style>
.el-menu {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// share-container.vue?5787c0e8